module.exports = __webpack_public_path__ + "img/folder-search.78005891.svg";